//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { navsList } from "../../utils/enum";
export default {
  name: "headerReturn",
  computed: {
    backIconWidthHeight() {
      return this.$screen.mobile ? "16px" : "21px";
    },
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    isCustom: {
      type: Boolean,
      default: false,
    },
    isBtnShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navsList,
      allNavs: [],
    };
  },
  created() {
    this.switchRoute();
  },
  methods: {
    async switchRoute() {
      this.allNavs = [];
      await this.navsList.forEach((item) => {
        if (item.location && item.location != "") {
          this.allNavs.push({
            index: item.index,
            location: item.location,
          });
        }
        if (item.children && item.children.length > 0) {
          item.children.forEach((child) => {
            if (child.location && child.location != "") {
              this.allNavs.push({
                index: child.index,
                location: child.location,
              });
            }
            if (child.children && child.children.length > 0) {
              child.children.forEach((grandChild) => {
                if (grandChild.location && grandChild.location != "") {
                  this.allNavs.push({
                    index: grandChild.index,
                    location: grandChild.location,
                  });
                }
              });
            }
          });
        }
      });
      console.log("this.allNavs==", this.allNavs);
    },
    onBackHandle() {
      const _this = this;
      const currentPath = _this.$route.name;
      console.log("currentPath==", currentPath);
      let newArr = _this.allNavs.filter((item) => item.location.name == currentPath);
      console.log('newArr=',newArr);
      if (newArr.length > 0) {
        this.$router.push({ name: "home" });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
